module.exports = __webpack_public_path__ + "img/Event.c7af689b.png";